import { createSlice } from '@reduxjs/toolkit';

// ─── Initial State ────────────────────────────────────────────────────────────

const initialState = {
  generalData: {
    fields: {
      // User & incident
      userNotVerifiedRestricted:          false,
      incidentType:                        false,
      isVerifiedToReport:                  false,
      shippingIdToReport:                  '',
      // Beneficio de disputa por score de confianza. NO viene del login: lo revalida
      // ReportInfo contra /disputes/benefit/ cada vez que hay guía capturada, porque el
      // score se recalcula por cron y el admin puede mover el switch, el mínimo o la
      // lista negra entre el login y el reclamo.
      disputeBenefit:                      false,
      // ¿Cabe hoy un reembolso en el presupuesto global? Es lo que decide si se puede
      // prometer "te reembolsaremos el saldo" en un cargo YA cobrado. El caso PAUSA
      // (cargo no cobrado) no depende de esto: ahí no se mueve dinero.
      disputeReimbursementAvailable:       false,

      // Collections
      insuranceCategories:                 [],
      policyBeneficiaries:                 [],
      addressesFrom:                       [],
      addressesTo:                         [],
      parcels:                             [],

      // Destination notifications
      destinationNotificationsEnabled:      null,
      destinationNotificationsEnabledEmail: null,
      destinationNotificationsEnabledWhatsapp: null,

      // Internal notifications
      internalNotificationsEnabled:         null,
      internalNotificationsEmailEnabled:    null,
      internalNotificationsWhatsappEnabled: null,
      internalNotificationsWebhookEnabled:  null,
      internalNotificationsSMSEnabled:      null,
    },
  },
};

// ─── Slice ────────────────────────────────────────────────────────────────────

const generalDataSlice = createSlice({
  name: 'generalData',
  initialState,
  reducers: {

    // Generic setter
    setGeneralData(state, action) {
      const { point, data } = action.payload;
      state.generalData.fields[point] = data;
    },

    // Collections
    setInsuranceCategories(state, action) {
      state.generalData.fields.insuranceCategories = action.payload.data;
    },
    setPolicyBeneficiaries(state, action) {
      state.generalData.fields.policyBeneficiaries = action.payload.data;
    },
    setAddressesFrom(state, action) {
      state.generalData.fields.addressesFrom = action.payload.data;
    },
    setAddressesTo(state, action) {
      state.generalData.fields.addressesTo = action.payload.data;
    },
    setParcels(state, action) {
      state.generalData.fields.parcels = action.payload.data;
    },

    // Destination notifications
    setDestinationNotificationsEnabled(state, action) {
      state.generalData.fields.destinationNotificationsEnabled = action.payload;
    },
    setDestinationEmailNotificationsEnabled(state, action) {
      state.generalData.fields.destinationNotificationsEnabledEmail = action.payload;
    },
    setDestinationWhatsappNotificationsEnabled(state, action) {
      state.generalData.fields.destinationNotificationsEnabledWhatsapp = action.payload;
    },

    // Internal notifications
    setInternalNotificationsEnabled(state, action) {
      state.generalData.fields.internalNotificationsEnabled = action.payload;
    },
    setInternalEmailNotificationEnabled(state, action) {
      state.generalData.fields.internalNotificationsEmailEnabled = action.payload;
    },
    setInternalWhatsappNotificationEnabled(state, action) {
      state.generalData.fields.internalNotificationsWhatsappEnabled = action.payload;
    },
    setInternalWebhookNotificationEnabled(state, action) {
      state.generalData.fields.internalNotificationsWebhookEnabled = action.payload;
    },
    setInternalSMSNotificationEnabled(state, action) {
      state.generalData.fields.internalNotificationsSMSEnabled = action.payload;
    },

    // User verification
    setUserNotVerifiedRestricted(state, action) {
      state.generalData.fields.userNotVerifiedRestricted = action.payload;
    },

  },
});

// ─── Exports ──────────────────────────────────────────────────────────────────

// Imported in file.js
export const {
  setGeneralData,
  setInsuranceCategories,
  setPolicyBeneficiaries,
  setAddressesFrom,
  setAddressesTo,
  setParcels,
  setUserNotVerifiedRestricted,
  setDestinationNotificationsEnabled,
  setDestinationEmailNotificationsEnabled,
  setDestinationWhatsappNotificationsEnabled,
  setInternalNotificationsEnabled,
  setInternalEmailNotificationEnabled,
  setInternalWhatsappNotificationEnabled,
  setInternalWebhookNotificationEnabled,
  setInternalSMSNotificationEnabled,
} = generalDataSlice.actions;

// Used in store.js
const generalDataReducer = generalDataSlice.reducer;
export default generalDataReducer;